import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartData, ChartOptions } from 'chart.js';
import { useEffect, useState } from 'react';
import { ExamPracticeDoneStat } from 'model/response';
import { getStatExamPracticeDone } from 'service/statisticService';

// Register necessary components for ChartJS
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Define types for the data prop
interface DataItem {
    month: string; // Assumes month is a string in 'YYYY-MM-DD' format
    examCompletedCount: number;
    practiceCompletedCount: number;
}

interface MonthlyCompletionChartProps {
    data?: DataItem[];
}
const MonthlyCompletionChart: React.FC<MonthlyCompletionChartProps> = () => {
    const [data,setData] = useState<ExamPracticeDoneStat[]>()

    const initData = ()=> {
        getStatExamPracticeDone()
         .then(response => {
            setData(response)
         })
    }

    useEffect(() => {
        initData()
    },[])
    // Extract labels and data from the server response
    const labels = data?.map(item => item?.description);
    const examData = data?.map(item => item.examCompletedCount || 0) || [];
    const practiceData = data?.map(item => item.practiceCompletedCount || 0) || []; // Default to 0 if undefined
    const totalExams = examData?.reduce((sum, count) => (sum??0) + (count ?? 0), 0);
    const totalPractices = practiceData?.reduce((sum, count) => (sum??0) + (count ?? 0), 0);

    // Chart data structure 
    const chartData: ChartData<'bar'> = {
        labels: labels,
        datasets: [
            {
                label: `Đề thi đã làm (tổng: ${totalExams})`, // Only show total in the legend
                data: examData,
                backgroundColor: 'rgba(59, 130, 246,0.8)', // Blue color
                borderWidth: 1,
                barPercentage: 0.8,
                categoryPercentage: 0.3,
            },
            {
                label: `Bài luyện tập đã làm (tổng: ${totalPractices})`, // Only show total in the legend
                data: practiceData,
                backgroundColor: 'rgba(234, 88, 12,0.8)', // Orange color
                borderWidth: 1,
                barPercentage: 0.8,
                categoryPercentage: 0.3,
            },
        ],
    };

    // Chart options
    const options: ChartOptions<'bar'> = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' as const,
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                },
            },
            title: {
                display: true,
                text: 'Thống kê số lượng bài kiểm tra, bài luyện tập',
                font: {
                    size: 17,
                },
                padding: {
                    bottom: 20,
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        return context.dataset.label
                    },
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Tháng',
                },
            },
            y: {
                beginAtZero: true,
                title: {
                    display: false,
                    text: 'Count',
                },
            },
        },
    };
    return (
        <div className='flex justify-center'>
          <Bar data={chartData} options={options} height={200}/>
        </div>
      );
};

export default MonthlyCompletionChart;
